export default __webpack_public_path__ + "4bf825db937f9db07295bade713764fa.svg";